/* eslint-disable space-in-parens */
import React from 'react'
import PropTypes from 'prop-types'

class SearchBar extends React.Component {
  static propTypes = {
    valueInit: PropTypes.string,
  }
  constructor (props) {
    super(props)
    window.pro4 = this.state
    this.handleGo = this.handleGo.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      search: this.props.valueInit
    }
  }

  handleChange (event) {
    this.setState({ search: event.target.value })
  }
  handleGo (event) {
    window.location.href = '/tim-kiem/' + this.state.search
    event.preventDefault()
    return false
  }
  render () {
    return (
      <section className='advanced-search advance-search-header'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12'>
              <form>
                <div className='form-group search-long'>
                  <div className='search'>
                    <div className='input-search input-icon'>
                      <input className='form-control' type='text' value={this.state.search}
                        placeholder='Tìm kiếm sản phẩm' onChange={this.handleChange} />
                    </div>
                    {/*<select name='location' className='selectpicker bs-select-hidden'*/}
                      {/*data-live-search='false' data-live-search-style='begins'>*/}
                      {/*<option value=''>All Cities</option>*/}
                      {/*<option value='chicago'> Chicago</option>*/}
                      {/*<option value='los-angeles'> Los Angeles</option>*/}
                      {/*<option value='miami'> Miami</option>*/}
                      {/*<option value='new-york'> New York</option>*/}
                    {/*</select>*/}
                    {/*<select name='area' className='selectpicker bs-select-hidden'*/}
                      {/*data-live-search='false' data-live-search-style='begins'>*/}
                      {/*<option value=''>All Areas</option>*/}
                      {/*<option value='beverly-hills'> Beverly Hills</option>*/}
                      {/*<option value='brickell'> Brickell</option>*/}
                      {/*<option value='brickyard'> Brickyard</option>*/}
                      {/*<option value='bronx'> Bronx</option>*/}
                      {/*<option value='brooklyn'> Brooklyn</option>*/}
                      {/*<option value='coconut-grove'> Coconut Grove</option>*/}
                      {/*<option value='downtown'> Downtown</option>*/}
                      {/*<option value='eagle-rock'> Eagle Rock</option>*/}
                      {/*<option value='englewood'> Englewood</option>*/}
                      {/*<option value='hermosa'> Hermosa</option>*/}
                      {/*<option value='hollywood'> Hollywood</option>*/}
                      {/*<option value='lincoln-park'> Lincoln Park</option>*/}
                      {/*<option value='manhattan'> Manhattan</option>*/}
                      {/*<option value='midtown'> Midtown</option>*/}
                      {/*<option value='queens'> Queens</option>*/}
                      {/*<option value='westwood'> Westwood</option>*/}
                      {/*<option value='wynwood'> Wynwood</option>*/}
                    {/*</select>*/}
                    {/*<div className='advance-btn-holder'>*/}
                      {/*<button className='advance-btn btn' type='button'><i className='fa fa-gear' /> Advanced</button>*/}
                    {/*</div>*/}
                  </div>
                  <div className='search-btn'>
                    <span onClick={this.handleGo} className='btn btn-secondary'>Go</span>
                  </div>
                </div>
                {/*<div className='advance-fields'>*/}
                  {/*<div className='row'>*/}
                    {/*<div className='col-sm-3 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='true' data-live-search-style='begins'*/}
                          {/*title='Status'>*/}
                          {/*<option>Status 1</option>*/}
                          {/*<option>Status 2</option>*/}
                          {/*<option>Status 3</option>*/}
                          {/*<option>Status 4</option>*/}
                          {/*<option>Status 5</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-3 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='true' data-live-search-style='begins'*/}
                          {/*title='Property Type'>*/}
                          {/*<option>Property Type 1</option>*/}
                          {/*<option>Property Type 2</option>*/}
                          {/*<option>Property Type 3</option>*/}
                          {/*<option>Property Type 4</option>*/}
                          {/*<option>Property Type 5</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-3 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='true' data-live-search-style='begins'*/}
                          {/*title='Beds'>*/}
                          {/*<option>01</option>*/}
                          {/*<option>02</option>*/}
                          {/*<option>03</option>*/}
                          {/*<option>04</option>*/}
                          {/*<option>05</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-3 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='true' data-live-search-style='begins'*/}
                          {/*title='Baths'>*/}
                          {/*<option>01</option>*/}
                          {/*<option>02</option>*/}
                          {/*<option>03</option>*/}
                          {/*<option>04</option>*/}
                          {/*<option>05</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-3 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='true' data-live-search-style='begins'*/}
                          {/*title='Min Areas (Sqft)'>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-3 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='true' data-live-search-style='begins'*/}
                          {/*title='Max Areas (Sqft)'>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                          {/*<option>$100</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-6'>*/}
                      {/*<div className='range-advanced-main'>*/}
                        {/*<div className='range-text'>*/}
                          {/*<input type='text' className='min-price-range-hidden range-input' />*/}
                          {/*<input type='text' className='max-price-range-hidden range-input' />*/}
                          {/*<p>*/}
                            {/*<span className='range-title'>Price Range:</span>*/}
                            {/*from*/}
                            {/*<span className='min-price-range' />*/}
                            {/*to*/}
                            {/*<span className='max-price-range' /></p>*/}
                        {/*</div>*/}
                        {/*<div className='range-wrap'>*/}
                          {/*<div className='price-range-advanced' />*/}
                        {/*</div>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-12 col-xs-12 features-list'>*/}

                      {/*<label className='advance-trigger text-uppercase title'>*/}
                        {/*<i className='fa fa-plus-square' /> Other Features </label>*/}
                      {/*<div className='clearfix' />*/}
                      {/*<div className='field-expand'>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                  {/*</div>*/}
                {/*</div>*/}
              </form>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/SearchBar.js